var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { StackItem } from './StackItem';
export const Stack = React.forwardRef((_a, ref) => {
    var { children, className, vertical = false, spacing = 0, distribution = 'leading', alignment = 'fill', nowrap = false, wrap = 'nowrap', direction = 'row', justifyContent = 'flex-start', alignItems = 'stretch', alignContent = 'stretch' } = _a, rest = __rest(_a, ["children", "className", "vertical", "spacing", "distribution", "alignment", "nowrap", "wrap", "direction", "justifyContent", "alignItems", "alignContent"]);
    React.useEffect(() => {
        if (nowrap) {
            console.warn('@servicetitan/design-system: The `nowrap` prop of the Stack component has been deprecated. Please use `wrap` instead.');
        }
        if (alignment !== 'fill') {
            console.warn('@servicetitan/design-system: The `alignment` prop of the Stack component has been deprecated. Please use `alignItems` instead.');
        }
        if (distribution !== 'leading') {
            console.warn('@servicetitan/design-system: The `distribution` prop of the Stack component has been deprecated. Please use `justifyContent` instead.');
        }
        if (vertical) {
            console.warn('@servicetitan/design-system: The `vertical` prop of the Stack component has been deprecated. Please use `direction` instead.');
        }
    }, [nowrap, alignment, distribution, vertical]);
    const getFlexWrap = () => {
        if (nowrap)
            return 'wrap';
        return wrap;
    };
    const getFlexDirection = () => {
        if (vertical)
            return 'column';
        return direction;
    };
    const getFlexJustifyContent = () => {
        const justificationConverter = {
            leading: 'flex-start',
            trailing: 'flex-end',
            center: 'center',
            equalSpacing: 'space-between',
        };
        if (distribution !== 'leading')
            return justificationConverter[distribution];
        return justifyContent;
    };
    const getFlexAlignItems = () => {
        const alignmentConverter = {
            leading: 'flex-start',
            trailing: 'flex-end',
            center: 'center',
            fill: 'stretch',
            baseline: 'baseline',
        };
        if (alignment !== 'fill')
            return alignmentConverter[alignment];
        return alignItems;
    };
    const realWrap = getFlexWrap();
    const realDirection = getFlexDirection();
    const realJustifyContent = getFlexJustifyContent();
    const realAlignItems = getFlexAlignItems();
    const StackClasses = classnames('Stack', className);
    const StackWrapperClasses = classnames('Stack__InternalWrapper', {
        [`Stack--spacing-${spacing}`]: spacing,
        [`Stack--wrap-${realWrap}`]: realWrap,
        [`Stack--direction-${realDirection}`]: realDirection,
        [`Stack--justify-content-${realJustifyContent}`]: realJustifyContent,
        [`Stack--align-items-${realAlignItems}`]: realAlignItems,
        [`Stack--align-content-${alignContent}`]: alignContent,
    });
    return (React.createElement("div", Object.assign({ className: StackClasses, ref: ref, "data-anvil-component": "Stack" }, rest),
        React.createElement("div", { className: StackWrapperClasses }, children)));
});
Stack.Item = StackItem;
//# sourceMappingURL=Stack.js.map